var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocketIconDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08761 1.83405C6.08666 1.83425 6.06961 1.83787 6.04329 1.87166L1.37779 7.86028C1.33022 7.92133 1.31836 8.01042 1.35141 8.093C1.38433 8.17526 1.42494 8.17672 1.43308 8.17672H3.70231C4.36483 8.17672 4.80138 8.76254 4.80138 9.35341V13.9887C4.80138 14.1074 4.85929 14.1508 4.885 14.1618C4.89971 14.1681 4.90825 14.1668 4.91138 14.166L4.91142 14.166C4.91236 14.1658 4.92941 14.1622 4.95574 14.1284L9.62124 8.13979C9.66881 8.07874 9.68067 7.98965 9.64762 7.90707C9.6147 7.82481 9.57409 7.82335 9.56595 7.82335H7.29672C6.6342 7.82335 6.19765 7.23753 6.19765 6.64666V2.01141C6.19765 1.89262 6.13974 1.84922 6.11403 1.83826C6.09932 1.83199 6.09078 1.83326 6.08765 1.83404L6.08761 1.83405ZM6.50614 0.918342C6.9136 1.09202 7.19765 1.50632 7.19765 2.01141V6.64666C7.19765 6.7143 7.22191 6.76483 7.24749 6.79372C7.27223 6.82167 7.29058 6.82335 7.29672 6.82335H9.56595C10.0733 6.82335 10.4278 7.16518 10.576 7.53551C10.7241 7.9055 10.7031 8.37828 10.4101 8.75436L5.74461 14.743C5.41832 15.1618 4.91145 15.2601 4.49289 15.0817C4.08543 14.908 3.80138 14.4938 3.80138 13.9887V9.35341C3.80138 9.28577 3.77712 9.23524 3.75154 9.20635C3.7268 9.1784 3.70845 9.17672 3.70231 9.17672H1.43308C0.925737 9.17672 0.571207 8.83489 0.422999 8.46456C0.274923 8.09457 0.295938 7.62179 0.588925 7.24571L5.25442 1.25709C5.5807 0.838277 6.08758 0.739938 6.50614 0.918342Z",
    fill: "url(#paint0_linear_243_801)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_243_801",
    x1: 19.0355,
    y1: -0.194991,
    x2: -20.1303,
    y2: 17.4541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF6633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273470"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocketIconDanger);
export default __webpack_public_path__ + "static/media/socketIconDanger.2de81ef4395cc684bc4ed83338a72e03.svg";
export { ForwardRef as ReactComponent };